// extracted by mini-css-extract-plugin
module.exports =  {"dropdown":"_0d624b9a27--dropdown--DX7TI"};